import { render, staticRenderFns } from "./screenshot-gallery.vue?vue&type=template&id=4799b678"
import script from "./screenshot-gallery.vue?vue&type=script&lang=js"
export * from "./screenshot-gallery.vue?vue&type=script&lang=js"
import style0 from "./screenshot-gallery.vue?vue&type=style&index=0&id=4799b678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports